export class AccountStatusChangeCommand{
    accountNumber: string;
    newStatus: string;

    constructor(accountNumber: string, newStatus: string){
        this.accountNumber = accountNumber;
        this.newStatus = newStatus;
    }
}